import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  instant?: boolean;
}
// Check once at module level
const prefersReducedMotion = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up',
  instant = false
}: FadeInProps) {
  // Skip animations entirely if instant or user prefers reduced motion
  if (instant || prefersReducedMotion) {
    return <div className={className} data-id="element-378">{children}</div>;
  }
  const variants = {
    hidden: {
      opacity: 0,
      y: direction === 'up' ? 20 : direction === 'down' ? -20 : 0,
      x: direction === 'left' ? 20 : direction === 'right' ? -20 : 0
    },
    visible: {
      opacity: 1,
      y: 0,
      x: 0,
      transition: {
        duration: 0.4,
        ease: [0.22, 1, 0.36, 1],
        delay: delay
      }
    }
  };
  return <motion.div initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-30px'
  }} variants={variants} className={className} data-id="element-379">
      {children}
    </motion.div>;
}